/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedShippingInfo_viewer = {
    readonly showShippingDiscounts: boolean | null;
    readonly regionalInfo: ReadonlyArray<{
        readonly countryName: string | null;
        readonly zipCode: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"useShippingPrice_viewer" | "PdpSharedPromoCode_viewer">;
    readonly " $refType": "PdpSharedShippingInfo_viewer";
};
export type PdpSharedShippingInfo_viewer$data = PdpSharedShippingInfo_viewer;
export type PdpSharedShippingInfo_viewer$key = {
    readonly " $data"?: PdpSharedShippingInfo_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_viewer",
  "selections": [
    {
      "alias": "showShippingDiscounts",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "subsidizedShippingPDP"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"subsidizedShippingPDP\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "countryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "userZipCode"
        }
      ],
      "concreteType": "RegionalInfo",
      "kind": "LinkedField",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zipCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '2acb2759ca68faef24794e813ca2c092';
export default node;
